export const leadStatusValidationRules = (values) => {
  const errors = {};

  if (!values.name) errors.name = "Status is required";
  if (values.name && values.name.length < 3) errors.name = "Status must be at least 3 characters";

  return errors;
};

export const leadValidationRules = (values, isUpdate) => {
  const errors = {};
  const phoneRegex = /^\+[1-9]\d{0,3}\d{6,11}$/;

  if (!values.contactName) errors.contactName = "Contact Name is required";
  else if (values.contactName.length < 3) errors.contactName = "Contact Name must be at least 3 characters";
  if (!values.contactPhone) errors.contactPhone = "Mobile number is required";
  else if (!phoneRegex.test(values.contactPhone)) errors.contactPhone = "Enter valid number (with country code)";

  if (!isUpdate && !values.statusId) errors.statusId = "Please select a status";
  if (!isUpdate && !values.priorityId) errors.priorityId = "Please select a priority";

  const hasAssignees = Array.isArray(values.assigneeIds)
    ? values.assigneeIds.length > 0
    : Array.isArray(values.assignees)
      ? values.assignees.length > 0
      : values.assigneeId != null && values.assigneeId !== "";
  if (!isUpdate && !hasAssignees) errors.assigneeIds = "Please select at least one assignee";

  return errors;
};

export const leadActivityValidationRules = (values) => {
  const errors = {};

  if (!values.note) errors.note = "Please add a note";
  if (values.note && values.note.length < 5) errors.note = "Note must be at least 5 characters";
  const hasAssignees = Array.isArray(values.assignees) && values.assignees.length > 0;
  if (!hasAssignees) errors.assignees = "Please select at least one assignee";

  return errors;
};
